import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { RegistrarAccidentePage } from './registrar-accidente.page';

const routes: Routes = [
  {
    path: '',
    component: RegistrarAccidentePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [RegistrarAccidentePage]
})
export class RegistrarAccidentePageModule {}
